import React, { Component } from 'react';
import http from '../modules/api';

import TextInput from "../modules/common/TextInput";
import SelectBoxV2 from '../modules/common/SelectBoxV2';
import SaveDialogV2 from '../modules/dialogs/SaveDialogV2';
import BasicDialogV2 from "../modules/dialogs/BasicDialogV2";
import WarningDialog from "../modules/dialogs/WarningDialog";
import ConfirmDialogV2 from '../modules/dialogs/ConfirmDialogV2';
import RoboImgSettingPopup from '../autoEvent/component/RoboImgSettingPopup';
import SearchProductPopup from '../modules/popup/SearchProductPopup';
import PopupFrameV2 from '../modules/popup/PopupFrameV2';
import CheckBox from "../modules/common/CheckBox";
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'

import DatePicker from "react-datepicker";
import { ko, te } from "date-fns/locale";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors
  } from "@dnd-kit/core";
import {
    arrayMove as arraymMoveByDndKit,
    SortableContext,
    useSortable,
    rectSortingStrategy
  } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { is } from 'immutable';

const FACEBOOK_APP_ID = '780456611206591';
const BASEDOMAIN = document.domain.indexOf("127.0.0.1") >= 0 ? 'https://127.0.0.1:8092' : "https://robomd.io";
const REDIRECT_URI = BASEDOMAIN + '/rest/shop/instagram/callbackForRefleshParent';
const SCOPES = [
    'pages_show_list',
    // 'pages_read_engagement',
    'business_management',
    'instagram_basic',
    'instagram_content_publish',
    'instagram_manage_insights',
    // 'catalog_management',
    // 'instagram_shopping_tag_products',
    'public_profile'
].join(',');

const PUBLISH_CYCLE_OPTIONS = [
  { label: "매일", value: "DAILY" },
  { label: "매주", value: "WEEKLY" },
  { label: "격일", value: "BIDAY" },
  { label: "주 3회", value: "3TIMES" },
  // { label: "커스텀", value: "CUSTOM" },
];

/** 현재 value(publishCycle)로부터 라벨을 얻는 유틸 */
function getLabelByValue(list, value) {
  const f = list.find(o => o.value === value);
  return f ? f.label : "";
}

// +0000 → +00:00 or Z 로 정규화
const parseBackendISO = (s) => {
  if (!s) return null;
  // 끝의 +0000 / +0900 형태를 +00:00 / +09:00 로 변환
  const fixed = s.replace(/([+-]\d{2})(\d{2})$/, '$1:$2')
                 .replace('+00:00', 'Z'); // 정확히 +00:00이면 Z로
  const d = new Date(fixed);
  return isNaN(d.getTime()) ? null : d;
};

const parseStartDateString = (v) => {
  if (!v) return format(new Date(), 'yyyy-MM-dd');
  // 이미 "YYYY-MM-DD"면 그대로
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return v;

  // ISO(+0000) 등도 허용: +0000 → +00:00 로 보정
  const fixed = String(v).replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
  const d = new Date(fixed);
  return isNaN(d.getTime()) ? format(new Date(), 'yyyy-MM-dd') : 
                              format(d, 'yyyy-MM-dd');
};

// "HH:mm" 형태로 고정
const parseTimeStringHHmm = (v) => {
  if (!v) return '00:00';
  // "HH:mm" 또는 "HH:mm:ss" 허용
  const m = String(v).trim().match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
  if (m) {
    const hh = m[1].padStart(2, '0');
    const mm = m[2].padStart(2, '0');
    return `${hh}:${mm}`;
  }
  // Date 객체가 들어오는 경우도 방어
  if (v instanceof Date && !isNaN(v.getTime())) {
    const hh = String(v.getHours()).padStart(2, '0');
    const mm = String(v.getMinutes()).padStart(2, '0');
    return `${hh}:${mm}`;
  }
  // 그 외엔 기본값
  return '00:00';
};

/**
 * @param {string} caption
 * @param {object} opt
 * @param {boolean} [opt.keepNumericTags=false]   // #123을 남길지 여부 (기본: 제거)
 * @param {string[]} [opt.allowlistPrefixes=[]]   // 허용 접두어 (예: ['A-', 'PRJ-'])
 * @param {boolean} [opt.preserveMarkdownHeader=false]
 * @param {boolean} [opt.removeUrls=true]
 */
function sanitizeCaption(caption, opt = {}) {
  if (!caption) return { text: caption, removedTags: [] };

  const cfg = {
    keepNumericTags: false,
    allowlistPrefixes: [],
    preserveMarkdownHeader: false,
    removeUrls: true,
    ...opt
  };

  let t = caption;
  const removedTags = [];

  // 0) URL 처리
  if (cfg.removeUrls) {
    t = t.replace(/\bhttps?:\/\/\S+/gi, "");
  }

  // 1) 보호 단계
  t = t.replace(/#[0-9a-fA-F]{3,8}\b/g, (m) => m.replace("#", "§C")); // HEX
  if (cfg.preserveMarkdownHeader) {
    t = t.replace(/^(#{1,6}\s+)/gm, (m) => m.replace(/#/g, "§H"));
  }

  // 2) 해시태그 블록 제거 (줄 시작이 # 인 라인들 덩어리)
  t = t.replace(/\r?\n(?:#[^\r\n]*\r?\n?)+$/m, "");

  // 3) 인라인 해시태그 제거/변환
  //   - 앞이 문장시작/공백/문장부호일 때의 #단어
  t = t.replace(/(^|[\s\p{P}])#([\p{L}\p{N}_\-]+)/gu, (m, lead, word) => {
    // 허용 접두어 화이트리스트(예: A-, PRJ- 등)
    if (cfg.allowlistPrefixes.some((p) => word.startsWith(p))) {
      return `${lead}${word}`; // 그대로 둠(# 제거)
    }
    // 숫자만 태그를 남길지
    if (cfg.keepNumericTags && /^\d+$/.test(word)) {
      return `${lead}${word}`; // 그대로 둠(# 제거)
    }
    // 기본: # 제거하고 단어만 남김
    removedTags.push(`#${word}`);
    return `${lead}${word}`;
  });

  // 4) 공백 정리 + 보호 복원
  t = t
    .replace(/[ \t]{2,}/g, " ")
    .replace(/\s+(\r?\n)/g, "$1")
    .replace(/\n{3,}/g, "\n\n")
    .trim()
    .replace(/§C/g, "#")
    .replace(/§H/g, "#");

  return { text: t, removedTags };
}

class InstagramCreateProductAutomation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      add_account_list: [],
      selected_account_list : [],

      settingSeq: window.location.search.includes("instagram_product_auto_setting_seq=") ? window.location.search.split("instagram_product_auto_setting_seq=")[1].split("&")[0] : null,

      // 기본 상태
      selectedRatio: '1/1',                   // '1/1' | '4/5' | '16/9'
      selectedFeedType: 'SINGLE',     // 'SINGLE' | 'SLIDE'
      selectedSlideCount: 2,          // 2..10
      selectedLogic: 'ORDERS',        // 'ORDERS' | 'NEW' | 'VIEWS' | 'ROBOMD'
      selectedRoboMD: '',
      isConnected: false,
      isConnecting: false,

      textMode: 'DIRECT',             // 'DIRECT' | 'AI'
      hashtagMode: 'BASIC',           // 'BASIC' | 'AI'
      timeMode: 'SPECIFIC',           // 'specific' | 'random'
      publishCycle: 'DAILY',          // select

      // 날짜/시간
      startDate: new Date().toISOString().split('T')[0],
      scheduledTime: '10:00',
      //   startTime: '10:00',
      //   endTime: '11:00',

      // 입력들
      customTexts: [''],
      hashtags: ['#여성의류 #쇼핑몰 #패션 #데일리룩'],
      textUserPrompt: "",

      // 요일 선택(일~토)
      activeDays: new Set(['월', '화', '수', '목', '금']),

      // 미리보기/모달
      showPreview: false,

      // 알림
      toast: null, // { type: 'success'|'error', message: string }

      /** 로딩 다이얼로그 */
      save_dialog_show_state: false,
      save_dialog_content: "로딩중 입니다.",
      save_dialog_button_list: [
          {
              title: "확인",
              type: "1",
              display_yn:"N",
          }
      ],

      /** 확인,취소 다이얼로그 */
      confirm_dialog_show_state : false,
      confirm_dialog_content : "",
      confirm_dialog_button_list : [],

      /* BasicDialog 변수 */
      basic_dialog_show_state: false,
      basic_dialog_content: "",
      basic_dialog_button_list: [{title:"확인", event_method:()=>{this.setState({basic_dialog_show_state:false})}}],

      /* 경고 다이얼로그 */
      warning_dialog_show_state: false,
      warning_dialog_content: "",
      warning_dialog_button_list: [{title:"확인", event_method:()=>{this.setState({warning_dialog_show_state:false})}}],

      emojiPickerVisible: false,

      feedCaptions: [
        // {"instagram_media_id": 1, "caption": "피드 문구 예시 1"},
        // {"instagram_media_id": 2, "caption": "피드 문구 예시 2"},
        // {"instagram_media_id": 3, "caption": "피드 문구 예시 3"},
        // {"instagram_media_id": 4, "caption": "피드 문구 예시 4"},
        // {"instagram_media_id": 5, "caption": "피드 문구 예시 5"},
      ],
      selectedLearnedFeedCaptions: [],
      selectedLearnedFeedCaptionsCnt: 0,
    };
  }

    componentDidMount() { 
        this.instagramFreePreriod();
        this.loadInstagramAccountList ();
        window.addEventListener('message', (e) => {
        // 보안: 허용된 origin만 처리
        // console.log("### e.data", e.data);
        if (e.data && e.data.type == 'refreshInstagramAccount') {
            if (e.data.token_id) {
              // alert("token_id : " + this.state.token_id);
              this.loadInstagramAccountList(e.data.token_id);
              this.setState({
                token_id: e.data.token_id,
                show_account_connect_popup: true
              })
            }
          
            // this.loadInstagramAccountList();
            return;
        }
        });
        this.loadRpEventSettingList();

        const { settingSeq } = this.state;
        if (settingSeq) {
          this.loadInstagramAutoProductSetting();
        }
    }

  // 공용: 토스트
  showToast = (message, type = 'success') => {
    this.setState({ toast: { message, type } });
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(() => this.setState({ toast: null }), 3000);
  };

  // 쇼핑몰 연동
  connectShop = () => {
    if (this.state.isConnected || this.state.isConnecting) return;
    this.setState({ isConnecting: true });
    // 연동 시뮬레이션
    setTimeout(() => {
      this.setState({ isConnected: true, isConnecting: false });
      this.showToast('쇼핑몰 연동이 완료되었습니다!', 'success');
    }, 1000);
  };

  // 피드 타입 선택
  selectFeedType = (type) => {
    this.setState({ selectedFeedType: type });
  };

  // 슬라이드 개수
  selectSlideCount = (count) => {
    this.setState({ selectedSlideCount: count });
  };

  // 상품 선택 로직
  selectLogic = (logic) => {
    this.setState({ selectedLogic: logic, selectedRoboMD: logic === 'robomd' ? this.state.selectedRoboMD : '' });
  };

  // 로보MD 선택
  selectRoboMD = (name) => {
    this.setState({ selectedRoboMD: name });
  };

  // 학습할 피드 선택
  selectLearnedFeed = (id, name) => {
    const { selectedLearnedFeedCaptions } = this.state;
    const copy = [...selectedLearnedFeedCaptions];

    const index = copy.findIndex(obj => obj.instagram_media_id == id);
    if (index !== -1) {
      // 이미 존재하면 제거
      copy.splice(index, 1);
    } else {
      // 없으면 추가
      copy.push({
        instagram_media_id: id,
        caption: name,
      });
    }

    this.setState({ selectedLearnedFeedCaptions: copy });
  };

  // 문구 모드
  setTextMode = (mode) => {
    this.setState({ textMode: mode });
  };

  // 해시태그 모드
  setHashtagMode = (mode) => {
    this.setState({ hashtagMode: mode });
  };

  // 시간 모드
  setTimeMode = (mode) => {
    this.setState({ timeMode: mode });
  };

  // 입력 핸들러
  handleChange = (e, path) => {
    const { name, value } = e.target;
    if (path === 'root') {
      this.setState({ [name]: value });
    }
  };

  // 커스텀 문구 추가/삭제/변경
  addCustomText = () => {
    this.setState((s) => ({ customTexts: [...s.customTexts, ''] }));
  };
  removeCustomText = (idx) => {
    this.setState((s) => {
      if (s.customTexts.length <= 1) {
        this.showToast('최소 1개의 문구는 필요합니다', 'error');
        return null;
      }
      const copy = [...s.customTexts];
      copy.splice(idx, 1);
      return { customTexts: copy };
    });
  };
  changeCustomText = (idx, val) => {
    this.setState((s) => {
      const copy = [...s.customTexts];
      copy[idx] = val;
      return { customTexts: copy };
    });
  };

  // 해시태그 추가/삭제/변경
  addHashtag = () => {
    this.setState((s) => ({ hashtags: [...s.hashtags, ''] }));
  };
  removeHashtag = (idx) => {
    this.setState((s) => {
      if (s.hashtags.length <= 1) {
        this.showToast('최소 1개의 해시태그는 필요합니다', 'error');
        return null;
      }
      const copy = [...s.hashtags];
      copy.splice(idx, 1);
      return { hashtags: copy };
    });
  };
  changeHashtag = (idx, val) => {
    this.setState((s) => {
      const copy = [...s.hashtags];
      copy[idx] = val;
      return { hashtags: copy };
    });
  };

  changeTextUserPrompt = (val) => {
    this.setState((s) => {
      return { textUserPrompt: val };
    });
  };

  // 요일 토글 (최소 1개 보장)
  toggleDay = (day) => {
    this.setState((s) => {
      const next = new Set(s.activeDays);
      if (next.has(day)) {
        if (next.size === 1) {
          this.showToast('최소 1개의 요일을 선택해주세요', 'error');
          return null;
        }
        next.delete(day);
      } else {
        if (this.state.publishCycle === '3TIMES' && next.size >= 3) {
          this.showToast('주 3회 발행 시 최대 3개의 요일만 선택할 수 있습니다', 'error');
          return null;
        }
        next.add(day);
      }
      return { activeDays: next };
    });
  };

  // 설정 저장 (localStorage)
  saveSettings = () => {
    const { isConnected, activeDays, startDate, selectedFeedType, selectedSlideCount, selectedLogic, selectedRoboMD, textMode, hashtagMode, publishCycle, timeMode, scheduledTime, customTexts, hashtags } = this.state;

    if (!isConnected) {
      this.showToast('먼저 쇼핑몰을 연동해주세요!', 'error');
      return;
    }
    if (!startDate) {
      this.showToast('시작일을 선택해주세요', 'error');
      return;
    }
    if (activeDays.size === 0) {
      this.showToast('발행 요일을 선택해주세요', 'error');
      return;
    }

    const settings = {
      feedType: selectedFeedType,
      slideCount: selectedSlideCount,
      logic: selectedLogic,
      roboMD: selectedRoboMD,
      textMode,
      hashtagMode,
      publishCycle,
      activeDays: Array.from(activeDays),
      timeMode,
      scheduledTime,
      startDate,
      customTexts,
      hashtags,
    };
    try {
      localStorage.setItem('instagramAutomationSettings', JSON.stringify(settings));
      this.showToast('상품 피드 자동화 설정이 저장되었습니다!', 'success');
      // 콘솔 확인용
      // eslint-disable-next-line no-console
      console.log('Saved settings:', settings);
    } catch (e) {
      this.showToast('저장 중 오류가 발생했습니다', 'error');
    }
  };

  // 미리보기 모달
  showPreviewModal = () => this.setState({ showPreview: true });
  closePreviewModal = () => this.setState({ showPreview: false });

  // 미리보기 계산
  getPreview = () => {
    const { selectedLogic, selectedRoboMD, hashtagMode, hashtags, textMode, customTexts, feedCaptions, selectedLearnedFeedCaptions } = this.state;

    // 콘텐츠/캡션
    let content = { text: '미리보기', bg: 'linear-gradient(135deg,#667eea 0%,#764ba2 100%)' };
    // let caption = '지금이 절호의 기회! 최대 70% 할인으로\n원하던 아이템을 저렴하게 만나보세요 ✨';
    let caption = '문구를 입력해주세요.';
    if (textMode === 'AI') {
      caption = ''
      // + 'AI 자동 생성에 사용 할' 
      + '입력한 프롬프트에 따른 맞춤 문구를 추천해 드립니다.';
    } else if (textMode === 'LEARN') {
      caption = ''
      // + 'AI 학습에 사용 할 피드 '
      + '선택한 피드 문구에 따른 맞춤 문구를 추천해 드립니다.';
    } else {
      caption = ''
      // + '인스타그램 피드에 사용 할 '
      + '문구를 입력해주세요.';
    }

    // if (selectedLogic === 'ORDERS') {
    //   content = { text: '🏆\n베스트 상품', bg: 'linear-gradient(135deg,#3b82f6 0%,#2563eb 100%)' };
    //   caption = '주문 폭주! 인기 상품을 놓치지 마세요 🔥\n재고 소진 임박!';
    // } else if (selectedLogic === 'NEW') {
    //   content = { text: '✨\nNEW ARRIVAL', bg: 'linear-gradient(135deg,#10b981 0%,#059669 100%)' };
    //   caption = '신상품이 도착했어요! 🎉\n얼리버드 10% 추가 할인 중';
    // } else if (selectedLogic === 'VIEWS') {
    //   content = { text: '👁️\nHOT ITEM', bg: 'linear-gradient(135deg,#ef4444 0%,#dc2626 100%)' };
    //   caption = '모두가 주목하는 핫 아이템 🔥\n조회수 1위 상품입니다';
    // } else if (selectedLogic === 'ROBOMD') {
    //   content = { text: '🤖\nAI 추천', bg: 'linear-gradient(135deg,#9333ea 0%,#7c3aed 100%)' };
    //   caption = 'AI가 분석한 당신을 위한 추천 상품 👍\n맞춤형 큐레이션';
    //   if (selectedRoboMD) caption += `\n${selectedRoboMD}`;
    // }

    if (textMode === 'DIRECT' && customTexts[0] && customTexts[0].trim()) {
      caption = customTexts[0];
    }
    if (textMode === 'LEARN' && selectedLearnedFeedCaptions && selectedLearnedFeedCaptions[0] && selectedLearnedFeedCaptions[0].caption?.trim()) {
      if (feedCaptions.length > 0) {
        let instagram_media_id = 0;
        for (let i = 0; i < feedCaptions.length; i++) {
          const fc = feedCaptions[i];
          for (let j = 0; j < selectedLearnedFeedCaptions.length; j++) {
            const feed = selectedLearnedFeedCaptions[j];
            if (fc.instagram_media_id == feed.instagram_media_id) {
              caption = fc.caption?.trim();
              instagram_media_id = fc.instagram_media_id;
              break; // inner loop break
            }
          }
          if (instagram_media_id) break; // outer loop도 중단 (첫 매칭만 찾을 때)
        }
      } else {
        caption = selectedLearnedFeedCaptions[0].caption?.trim();
      }
    }

    // 해시태그
    const hashtagsText =
      hashtagMode === 'AI'
        ? '#AI자동생성 #트렌드분석 #맞춤해시태그'
        : (hashtags[0] && hashtags[0].trim()) || '#해시태그를 입력해주세요.';

    return { content, caption, hashtagsText };
  };

  renderSlideButtons = () => {
    const { selectedSlideCount } = this.state;
    const items = [];
    for (let i = 2; i <= 10; i++) {
      items.push(
        <button
          key={i}
          className={`slide-option ${selectedSlideCount === i ? 'active' : ''}`}
          onClick={() => this.selectSlideCount(i)}
          type="button"
        >
          {i}개
        </button>
      );
    }
    return <div className="slide-options">{items}</div>;
  };

  renderCarouselDots = () => {
    const { selectedFeedType, selectedSlideCount } = this.state;
    if (selectedFeedType !== 'SLIDE') return null;
    const dots = [];
    for (let i = 0; i < selectedSlideCount; i++) {
      dots.push(<div key={i} className={`carousel-dot ${i === 0 ? 'active' : ''}`} />);
    }
    return <div className="carousel-dots">{dots}</div>;
  };

  renderDayButtons = () => {
    const days = ['일', '월', '화', '수', '목', '금', '토'];
    const { activeDays } = this.state;
    return (
      <div className="days-grid">
        {days.map((d) => (
          <button
            key={d}
            type="button"
            className={`day-button ${activeDays.has(d) ? 'active' : ''}`}
            onClick={() => this.toggleDay(d)}
          >
            {d}
          </button>
        ))}
      </div>
    );
  };

  renderRoboMDList = () => {
    const { selectedLogic, selectedRoboMD } = this.state;
    if (selectedLogic !== 'ROBOMD') return null;
    const list = this.state.rp_event_setting_list || [];
    return (
      <div id="roboMDList" className="robomd-list">
        <h4 style={{ marginBottom: 12, fontWeight: 600, fontSize: 16 }}>로보MD 진열 목록 선택</h4>
        <div style={{
            maxHeight: 220,
            overflow: "auto",
        }}>
          {
            list.length > 0 ? (
              list.map((obj) => (
              <button
                  key={obj.iframe_page_id+"|"+obj.iframe_html_id}
                  type="button"
                  className={`robomd-item ${selectedRoboMD == (obj.iframe_page_id+"|"+obj.iframe_html_id) ? 'active' : ''}`}
                  onClick={() => this.selectRoboMD((obj.iframe_page_id+"|"+obj.iframe_html_id))}
              >
                  {obj.display_name}
              </button>
              ))
            ): (
              <div style={{ fontSize: 14, color: "#6b7280"} }>
                로보MD 진열 목록이 없습니다. 먼저 로보MD 진열 설정을 생성해주세요.
              </div>
            )
          }
        </div>
      </div>
    );
  };

  loadRpEventSettingList() {
        http.get("/rest/shop/instagram/rp/event/setting/list")
        .then(res => {
            if (res.data.list != null) {
                const list = Array.isArray(res?.data?.list) ? res.data.list : [];
                this.setState({
                    rp_event_setting_list: list,
                });
            }
        })
  }

    loadInstagramAccountList (token_id) {
      if (token_id) {
        http.get("/rest/shop/instagram/profile/list?token_id=" + token_id)
          .then(res => {
            if (res.data.list != null) {
              this.setState({
                add_account_list: res.data.list,
              });
            }
          }).catch(error => {
            console.log(error);
          })
      }
      else {
        http.get("/rest/shop/instagram/profile/list")
        .then(res => {
            if (res.data.list != null) {
                console.log("res.data.list.length", res.data.list.length)
                // res.data.list가 없을 수도 있으니 안전하게 처리
                const list = Array.isArray(res?.data?.list) ? res.data.list : [];

                const account_list      = this.buildIgAccountOptions(list);
                const account_list_v2   = this.buildIgAccountOptionsV2(list);
                const defaultSeq        = this.buildIgDefaultAccount(list) || "";
                const key               = String(this.state.selected_ig_access_seq || defaultSeq || "");

                // acc.value 타입이 섞여 있을 수 있으니 문자열로 맞춰 비교
                const targetAcc = (account_list_v2 || []).find(acc => String(acc.value) === key) || null;

                this.setState({
                    account_list,
                    account_list_v2,
                    default_ig_access_seq: defaultSeq,
                    accountConnected: list.length > 0,
                    selectedAccount: targetAcc || null,
                }, () => {
                    console.log(
                    "account_list_v2.length:",
                    this.state.account_list_v2?.length || 0,
                    "default_ig_access_seq:",
                    this.state.default_ig_access_seq
                    );

                    this.fetchAllInstagramMedia(false, this.state.selected_ig_access_seq || this.state.default_ig_access_seq);
                });
            }
        }).catch(error => {
            console.error(error);
        })
      }
    }

  onChangeAccount = (text, value) => {
    // console.log("onChangeAccount", text, value);
    const targetAcc = (this.state.account_list_v2 || [])
      .find(acc => acc.value == value);
    this.setState({ 
      selected_ig_access_seq: value,
      selectedAccount: targetAcc || null,
    }, () => {
      // if (this.state.textMode === 'LEARN') {
        this.fetchAllInstagramMedia(true, this.state.selected_ig_access_seq || this.state.default_ig_access_seq);
      // }
    });
  };

  handleConnectAccount = () => {
    const authUrl = `https://www.facebook.com/v24.0/dialog/oauth?` +
      `client_id=${FACEBOOK_APP_ID}` +
      `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
      `&scope=${SCOPES}` +
      `&response_type=code`
      ;

    window.open(authUrl);
  };

  buildIgAccountOptions(apiPayload) {
    const src = apiPayload && (apiPayload.list || apiPayload) || [];
    const opts = [];

    src.forEach(fb => {
      const fbName = fb.facebook_username || "(이름 없음)";
      const igList = fb.instagram_account_list || [];
      igList.forEach(ig => {
        const v = String(ig.instagram_access_token_seq ?? "");
        if (!v) return; // 식별자 없으면 스킵
        const uname = ig.username ? `@${ig.username}` : "(계정명 없음)";
        opts.push({
          value: v,
          title: `${fbName} / ${uname}`,
        });
      });
    });

    return opts;
  }

  buildIgAccountOptionsV2(apiPayload) {
    const src = apiPayload && (apiPayload.list || apiPayload) || [];
    const opts = [];

    src.forEach(fb => {
      const igList = fb.instagram_account_list || [];
      igList.forEach(ig => {
        const v = String(ig.instagram_access_token_seq ?? "");
        if (!v) return; // 식별자 없으면 스킵
        const uname = ig.username ? `${ig.username}` : "(계정명 없음)";
        opts.push({
          value: v,
          title: `${uname}`,
          profile_picture_url: ig.profile_picture_url || null,
        });
      });
    });

    return opts;
  }

  // buildIgDefaultAccount(apiPayload) {
  //   const src = (apiPayload && (apiPayload.list || apiPayload)) || [];

  //   for (const fb of src) {
  //     const igList = fb.instagram_account_list || [];

  //     // 기본 계정(Y) 먼저 찾기
  //     const found = igList.find(ig => {
  //       const v = String(ig.instagram_access_token_seq ?? "");
  //       return v && ig.default_yn === 'Y';
  //     });

  //     // 없으면 첫 번째 계정 선택
  //     if (found) {
  //       return String(found.instagram_access_token_seq);
  //     } else if (igList.length > 0) {
  //       return String(igList[0].instagram_access_token_seq ?? "");
  //     }
  //   }

  //   return ""; // 모든 경우에 못 찾으면 빈 문자열
  // }

  buildIgDefaultAccount(apiPayload) {
    const src = (apiPayload && (apiPayload.list || apiPayload)) || [];
    
    // 1. 모든 facebook 객체에서 instagram_account_list를 추출하여 하나의 배열로 만듭니다.
    const allIgAccounts = src.reduce((acc, fb) => {
        return acc.concat(fb.instagram_account_list || []);
    }, []);

    if (allIgAccounts.length === 0) return "";

    // 2. 전체 배열에서 default_yn === 'Y'인 것을 찾습니다.
    const defaultAcc = allIgAccounts.find(ig => ig.default_yn === 'Y');

    // 3. 찾았다면 그 시퀀스를 반환, 없다면 배열의 첫 번째 계정을 반환합니다.
    if (defaultAcc) {
        return String(defaultAcc.instagram_access_token_seq ?? "");
    } else {
        return String(allIgAccounts[0].instagram_access_token_seq ?? "");
    }
  }

    getDateObjForDate = () => {
        const { startDate, scheduledTime } = this.state;
        if (!startDate) return null;
        // 시간 문자열이 있으면 함께 넣어도 되고, 없어도 날짜만 OK
        const time = scheduledTime || "00:00";
        return new Date(`${startDate}T${time}:00`);
      };
    
      getDateObjForTime = () => {
        const { startDate, scheduledTime } = this.state;
        // 시간 전용 피커는 기준 날짜가 필요하므로, 선택된 날짜가 있으면 그 날짜 사용
        const baseDate = startDate ? startDate : format(new Date(), "yyyy-MM-dd");
        const time = scheduledTime || "00:00";
        return new Date(`${baseDate}T${time}:00`);
      };
    
      onChangeDatePicker = (date) => {
        if (!date) {
          this.setState({ startDate: "" });
          return;
        }
        this.setState({ startDate: format(date, "yyyy-MM-dd") });
      };
    
      onChangeTimePicker = (date) => {
        if (!date) {
          this.setState({ scheduledTime: "" });
          return;
        }
        this.setState({ scheduledTime: format(date, "HH:mm") });
      };
     
  /**
   * 조회
   */
  loadInstagramAutoProductSetting = async () => {
    const { settingSeq } = this.state;

    try {
      this.setState({
        load_dialog_show_state: true,
        load_dialog_content: "불러오는 중입니다...",
      });

      const response = await http.get(
        "/rest/shop/instagram/auto/product/setting?settingSeq=" + settingSeq
      );

      if (response?.data?.result === "success") {
        const data = response.data.data || {};
        console.log("loadInstagramAutoProductSetting data:", data);

        const startDateObj = parseStartDateString(data.startDate);        // "2025-10-16" → Date(로컬)
        const timeObj      = parseTimeStringHHmm(data.scheduledTime);    // "10:00:00"  → Date(로컬, 오늘 날짜)
        console.log(">>> startDateObj", startDateObj, "timeObj", timeObj);

        let rp = data.rp || [];
        let selectedRoboMD = "";
        if (rp.iframe_page_id && rp.iframe_html_id) {
          selectedRoboMD = rp.iframe_page_id + "|" + rp.iframe_html_id;
        }
        console.log(">>> rp:", rp, "selectedRoboMD:", selectedRoboMD);
        this.setState({
          settingSeq: data.settingSeq,
          selected_ig_access_seq: data.instagramAccessTokenSeq,
          settingName: data.settingName,
          selectedFeedType: data.feedType,
          selectedSlideCount: data.slideCount,
          selectedLogic: data.productSelectLogic,
          textMode: data.textMode,
          hashtagMode: data.hashtagMode,
          publishCycle: data.publishCycle,
          timeMode: data.timeMode,
          textUserPrompt: data.textUserPrompt || "",
          
          // DatePicker 바인딩용
          startDate: startDateObj,           // 날짜 전용 DatePicker에 사용
          scheduledTime: timeObj,            // 시간 전용 DatePicker에 사용

          // 참고: 로그/표시용 UTC ISO 값들
          regDate: parseBackendISO(data.regDate),
          modDate: parseBackendISO(data.modDate),

          activeWeekdays: new Set(data.activeWeekdays || []),
          customTexts: data.captions || [],
          hashtags: data.hashtags || [],
          selectedRoboMD,
          selectedLearnedFeedCaptions: data.learnedCaption || [],
          selectedLearnedFeedCaptionsCnt: (data.learnedCaption || []).length,

          selectedRatio: data.image_ratio || '1/1',
        });

        // this.setState({
        //   basic_dialog_show_state: true,
        //   basic_dialog_content: "불러오기 완료되었습니다.",
        // });
      } else {
        alert("데이터를 불러오지 못했습니다.");
      }
    } catch (error) {
      const errMsg =
        error.response?.data?.message || error.message || "알 수 없는 오류";
      this.setState({ error: errMsg });
      alert("조회 실패: " + errMsg);
      console.error(error);
    } finally {
      this.setState({ load_dialog_show_state: false });
    }
  };


  /**
   * 저장
   */
  saveInstagramAutoProductSetting = async () => {
    const {
      settingSeq,
      selected_ig_access_seq,
      default_ig_access_seq,
      settingName,
      selectedFeedType,
      selectedSlideCount,
      selectedLogic,
      textMode,
      hashtagMode,
      publishCycle,
      timeMode,
      scheduledTime,
      startDate,
      activeDays,
      customTexts,
      hashtags,
      textUserPrompt,
      selectedRoboMD,
      selectedLearnedFeedCaptions,
      selectedRatio,
    } = this.state;

    
    if (!selected_ig_access_seq && !default_ig_access_seq) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "인스타그램 계정을 선택해주세요.",
      });
      return;
    }
    if(!selectedLogic) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "상품 선택 로직을 선택해주세요.",
      });
      return;
    }
    if(selectedFeedType === 'SLIDE' && (selectedSlideCount <2 || selectedSlideCount >10)) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "슬라이드 개수는 2~10개 사이로 선택해주세요.",
      });
      return;
    }
    if (textMode === 'DIRECT') {
      if (
        customTexts.length === 0 ||
        customTexts.every((text) => text.trim() === "")
      ) {
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: "최소 1개의 문구를 입력해주세요.",
        });
        return;
      }
    }
    if (textMode === 'AI') {
      if (!textUserPrompt || textUserPrompt.trim() === "") {
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: "AI 문구 생성을 위한 프롬프트를 입력해주세요.",
        });
        return;
      }
    }
    if (textMode === 'LEARN') {
      if (!selectedLearnedFeedCaptions || selectedLearnedFeedCaptions.length === 0) {
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: "학습할 피드를 최소 1개 이상 선택해주세요.",
        });
        return;
      }
    }
    if (hashtagMode === 'BASIC') {  
      if (
        hashtags.length === 0 ||
        hashtags.every((tag) => tag.trim() === "")
      ) {
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: "최소 1개의 해시태그를 입력해주세요.",
        });
        return;
      }
    }
    if (!startDate) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "날짜을 선택해주세요.",
      });
      return;
    }
    if (!scheduledTime) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "시간을 선택해주세요.",
      });
      return;
    }
    if (!activeDays || activeDays.size === 0) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "요일을 선택해주세요.",
      });
      return;
    }
    if (this.state.publishCycle === '3TIMES' && activeDays.size > 3) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "주 3회 발행 시 최대 3개의 요일만 선택할 수 있습니다.",
      });
      return;
    }

    // activeDays는 '일', '월'.. 형태이므로, 0~6 숫자 인덱스로 변환
    // (백엔드에서 0=일요일, 1=월요일.. 로 기대함)
    const days = activeDays ? Array.from(activeDays) : [];
    const daysIndexed = days.map((_, index) => index);
    const rp = {iframePageId: selectedRoboMD.split("|")[0] || "", iframeHtmlId: selectedRoboMD.split("|")[1] || ""}; 

    const body = {
      settingSeq,
      instagramAccessTokenSeq: selected_ig_access_seq || default_ig_access_seq,
      settingName,
      feedType: selectedFeedType,
      slideCount: selectedSlideCount,
      productSelectLogic: selectedLogic,
      textMode,
      hashtagMode,
      publishCycle,
      timeMode,
      scheduledTime,
      startDate,
      activeWeekdays: daysIndexed,
      captions : customTexts,
      hashtags,
      textUserPrompt,
      rp,
      selectedLearnedFeedCaptions,
      image_ratio : selectedRatio,
    };

    try {
      this.setState({ save_dialog_show_state: true, save_dialog_content: "저장 중입니다." });
      const response = await http.post(
        "/rest/shop/instagram/auto/product/setting/save",
        body,
        { headers: { "Content-Type": "application/json" } }
      );
      this.setState({ result: response.data });
      this.setState({ 
        save_dialog_show_state: false,
        basic_dialog_show_state: true,
        basic_dialog_content: `저장이 완료되었습니다.`,
        settingSeq: response.data.settingSeq,
       });
       
        const mediaId = data.media_id;
        const url = new URL(window.location.href);
        url.searchParams.set("instagram_product_auto_setting_seq", response.data.settingSeq);
        window.history.replaceState({}, "", url);
    } catch (error) {
      const errMsg =
        error.response?.data?.message || error.message || "알 수 없는 오류";
      this.setState({ error: errMsg });
      alert("저장 실패: " + errMsg);
    } finally {
      this.setState({ save_dialog_show_state: false });
    }
  };

  /**
   * 인스타그램 전체 피드 조회
   * @param {number|string} instagram_access_token_seq
   * @param {number} pageLimit
   * @param {number} maxItems
   */
  fetchAllInstagramMedia = (is_init = false, instagram_access_token_seq, pageLimit = 100, maxItems = 5000) => {
    if (!instagram_access_token_seq) {
      console.warn("instagram_access_token_seq is null");
      return;
    }
    http
      .get(`/rest/shop/instagram/${instagram_access_token_seq}/media/all`, {
        params: {
          pageLimit,
          maxItems,
        },
      })
      .then((response) => {
        const res = response.data;
        if (res && res.status === "success") {
          console.log("Instagram 미디어 조회 성공:", res.data.count);
          
          // Instagram 데이터 → feedCaptions 구조로 변환
          const feedCaptions = res.data.data
          .filter((item) => this.cleanCaption(item.caption)) // caption이 존재하는 것만
          .map((item) => ({
            instagram_media_id: item.id,
            caption: this.cleanCaption(item.caption),
          }));

          this.setState({ mediaList: res.data.data, feedCaptions, selectedLearnedFeedCaptions: is_init ? [] : this.state.selectedLearnedFeedCaptions, selectedLearnedFeedCaptionsCnt: is_init ? 0 : this.state.selectedLearnedFeedCaptionsCnt });
        } else {
          console.warn("Instagram 미디어 조회 실패:", res);
        }
      })
      .catch((error) => {
        console.error("Instagram 미디어 조회 오류:", error);
      });
  };

  instagramFreePreriod() {
    http.get("/rest/shop/instagram/FreePreriod")
    .then(res => {
        if (res.data.is_finish != null) {
            this.setState({
                instagram_is_finish: res.data.is_finish,
            });

            if (res.data.is_finish == 1) {
              alert("이용 기간이 종료되었습니다.");
              window.location.href = "/shop/instagram/InstagramProductAutomationList"; 
            }
        }
    }).catch(error => {
        console.error(error);
    })
  }


cleanCaption = (text) => {
  if (!text) return "";

  let caption = text;

  // 1️⃣ 문장 앞부분 해시태그 제거 (한 줄 시작에 여러 개 있는 경우)
  caption = caption.replace(/^\s*(#[A-Za-z0-9가-힣_]+\s*)+/gm, "");

  // 2️⃣ 문장 중간의 인물 태그 제거
  caption = caption.replace(/(^|\s)@[A-Za-z0-9._]+/g, "$1");

  // 3️⃣ 문장 끝 해시태그 블록 제거
  //     문장 끝에서부터 #태그들이 연속될 때 한 번에 잘라냄
  //     예: "여유를 얹어드려요.#신상품 #가을감성" → "여유를 얹어드려요."
  caption = caption.replace(/([^\n#]+?)(\s*#[A-Za-z0-9가-힣_]+)+\s*$/gm, "$1");

  // 4️⃣ 해시태그만 있는 줄 제거 (예: "#가을 #주말" → "")
  caption = caption.replace(/^\s*(#[A-Za-z0-9가-힣_]+\s*)+$/gm, "");

  // 5️⃣ 불필요한 공백 및 연속 줄바꿈 정리
  caption = caption.replace(/\n{2,}/g, "\n").trim();

  return caption;
};

updateAccountsUseYn = (token_id, selected_account_list, use_yn) => {
    return http.post(
      "/rest/shop/instagram/updateAccountsUseYn",
      { token_id, selected_account_list, use_yn },
      {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
  };

updateSelectedAccountsUseYn = () => {
    const { token_id, selected_account_list } = this.state;

    if (!selected_account_list || selected_account_list.length === 0) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "하나 이상의 계정을 선택 해 주세요."
      });
      return;
    }

    this.updateAccountsUseYn(token_id, selected_account_list, "Y")
      .then((res) => {
        const data = res && res.data ? res.data : {};
        if (String(data.code) === "200") {
          console.log("SUCCESS cnt:", data.cnt);
          this.loadInstagramAccountList();
          this.setState({
            show_account_connect_popup: false,
          });
        } else {
          console.log("FAIL:", data);
          this.setState({
            warning_dialog_show_state: true,
            warning_dialog_content: "계정 업데이트에 실패했습니다."
          });
        }
      })
      .catch((err) => {
        console.error("ERROR:", err);
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: "서버 요청 중 오류가 발생했습니다."
        });
      });
  };

  setRatio(ratio) {
      // document.querySelectorAll('.ratio-btn').forEach(b => b.classList.remove('active'));
      // btn.classList.add('active');
      // const container = document.getElementById('previewImgContainer');
      // container.className = 'insta-img-container';
      // if(ratio === '4/5') container.classList.add('ratio-4-5');
      // else if(ratio === 'original') container.classList.add('ratio-original');
      this.setState({ selectedRatio: ratio });
  }

  render() {
    const {
      isConnected,
      isConnecting,
      selectedFeedType,
      selectedLogic,
      textMode,
      hashtagMode,
      timeMode,
      publishCycle,
      startDate,
      scheduledTime,
      customTexts,
      hashtags,
      showPreview,
      toast,
      feedCaptions,
      selectedLearnedFeedCaptions,
      selectedAccount
    } = this.state;
    const { accountConnected, account_list } = this.state;
    const previewAccount = selectedAccount || {title: "계정명 없음", profile_picture_url: null};
    const { content, caption, hashtagsText } = this.getPreview();

    return (
      <>
        <style>
          {
            `
              /* Ratio Control */
              .ratio-control-box { background: #f8fafc; border: 1px solid #e5e7eb; border-radius: 8px; padding: 16px; margin-bottom: 20px; display: flex; align-items: center; justify-content: space-between; }
              .ratio-label { font-weight: 700; font-size: 15px; color: var(--deep-navy); display: flex; align-items: center; gap: 6px; }
              .ratio-group { display: flex; background: #e5e7eb; padding: 4px; border-radius: 8px; gap: 2px; }
              .ratio-btn { padding: 6px 16px; border-radius: 8px; border: 0px solid transparent; font-size: 14px; font-weight: 600; cursor: pointer; color: #64748b; background: transparent; transition: all 0.2s; display: flex; align-items: center; gap: 6px; }
              .ratio-btn:hover { color: var(--deep-navy); }
              .ratio-btn.active { background: white; color: var(--deep-navy); box-shadow: 0 2px 4px rgba(0,0,0,0.1); }
              /* .ratio-btn.active { border: solid 2px #00e2e6 !important; background: linear-gradient(135deg, #eff6ff 0%, rgb(242 252 254) 100%); color: var(--deep-navy); } */
              .icon-1-1 { width: 14px; height: 14px; border: 2px solid currentColor; border-radius: 2px; }
              .icon-4-5 { width: 12px; height: 15px; border: 2px solid currentColor; border-radius: 2px; }
              .icon-full { width: 16px; height: 10px; border: 2px solid currentColor; border-radius: 2px; }
            `
          }
        </style>
        <div id="InstagramProductAutomation">
            <div
                id="page-wrapper"
                className="container eventFormPromotion"
                style={{ backgroundColor: "#fafaf" }}
            >
            {/* 토스트 */}
            {toast && <div className={`notification ${toast.type}`}>{toast.message}</div>}

            <div className="main-container">
            {/* 좌측 컨텐츠 */}
            <div className="content-area">
                <div className="page-header">
                <h2 className="page-title">자동 설정</h2>
                <p className="page-subtitle">쇼핑몰 상품을 자동으로 인스타그램에 발행합니다</p>
                </div>

                {/* 연동 상태 */}
                {/* <div className="card">
                <div className="connection-status">
                    <div className="connection-info">
                    <h4>쇼핑몰 연동 상태</h4>
                    <p>상품 자동화를 위해 쇼핑몰과 연동이 필요합니다</p>
                    </div>
                    <button
                    className="button button-primary"
                    type="button"
                    onClick={this.connectShop}
                    disabled={isConnected || isConnecting}
                    >
                    {isConnected ? '✔ 연동 완료' : isConnecting ? '연동중...' : '연동하기'}
                    </button>
                </div>
                </div> */}

                {/* 계정 선택 */}
                <div className="card">
                <div className="content-section" style={{ marginBottom: 20 }}>
                    <h3 className="card-title">계정 선택</h3>
                    {/* <h3 className="section-title" style={{ fontSize: 16, marginBottom: 15 }}>
                    계정 선택
                    </h3> */}
        
                    {accountConnected ? (
                    <div id="accountList">
                        {/* <select
                        className="form-control"
                        value={selectedAccount}
                        onChange={this.onChangeAccount}
                        style={{ padding: "12px 15px", fontSize: 14, width: "100%", border: "1px solid #dbdbdb", borderRadius: 6 }}
                        >
                        <option value="">계정을 선택해주세요.</option>
                        <option value="@main_account">@main_account</option>
                        <option value="@sub_account">@sub_account</option>
                        <option value="@shop_account">@shop_account</option>
                        <option value="@brand_account">@brand_account</option>
                        <option value="@event_account">@event_account</option>
                        <option value="@test_account_01">@test_account_01</option>
                        <option value="@test_account_02">@test_account_02</option>
                        <option value="@marketing_team">@marketing_team</option>
                        <option value="@sales_team">@sales_team</option>
                        <option value="@cs_team">@cs_team</option>
                        </select> */}
                        <SelectBoxV2
                        id="ig_account_select"
                        tabIndex={0}
                        width="100%"
                        height="40px"
                        padding="8px 36px 8px 12px"
                        pageWrapperName="accountManagerWrap"
                        list={account_list || []}
                        optionTexttName="title"
                        optionValuetName="value"
                        selectedValue={this.state.selected_ig_access_seq || this.state.default_ig_access_seq || ""}
                        onClickOption={this.onChangeAccount}
                        />
                    </div>
                    ) : (
                    <div
                        id="noAccount"
                        style={{ background: "#fff8e1", border: "1px solid #ffd54f", borderRadius: 8, padding: 20 }}
                    >
                        <div className="noAccount_flex_box" style={{ display: "flex", alignItems: "center", gap: 15 }}>
                        <div
                            style={{
                            width: 40,
                            height: 40,
                            background: "#ff9800",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontWeight: "bold",
                            flexShrink: 0,
                            }}
                        >
                            !
                        </div>
                        <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 600, color: "#000", marginBottom: 5 }}>Instagram 계정을 연결해주세요</div>
                            <div style={{ fontSize: 14, color: "#666" }}>
                            게시물을 업로드하려면 먼저 Instagram 계정을 연결해야 합니다.
                            </div>
                        </div>
                        <button
                            className="btn btn-black"
                            onClick={this.handleConnectAccount}
                            style={{
                            flexShrink: 0,
                            background: "#000",
                            color: "white",
                            padding: "12px 24px",
                            borderRadius: 6,
                            border: "none",
                            fontWeight: 600,
                            fontSize: 14,
                            cursor: "pointer",
                            }}
                        >
                            계정 연결하기
                        </button>
                        </div>
                    </div>
                    )}
                </div>
                </div>

                {/* 피드 이미지 구성 */}
                <div className="card">
                <h3 className="card-title">피드 이미지 구성</h3>
                <div className="ratio-control-box">
                    <div className="ratio-label"><span style={{fontSize:18}}>📐</span> 비율 설정</div>
                    <div className="ratio-group">
                        <button className={"ratio-btn" + (this.state.selectedRatio === '1/1' ? ' active' : '')} onClick={e => {this.setRatio('1/1')}}>
                            <div className="icon-1-1"></div> 1:1 (정방형)
                        </button>
                        <button className={"ratio-btn" + (this.state.selectedRatio === '4/5' ? ' active' : '')} onClick={e => {this.setRatio('4/5')}}>
                            <div className="icon-4-5"></div> 4:5 (세로형)
                        </button>
                        <button className={"ratio-btn" + (this.state.selectedRatio === '16/9' ? ' active' : '')} onClick={e => {this.setRatio('16/9')}}>
                            <div className="icon-full"></div> 16:9 (가로형)
                        </button>
                    </div>
                </div>
                <div className="feed-type-grid">
                    <div
                    className={`feed-type-card ${selectedFeedType === 'SINGLE' ? 'active' : ''}`}
                    onClick={() => this.selectFeedType('SINGLE')}
                    role="button"
                    >
                    <div className="feed-type-icon">📱</div>
                    <div className="feed-type-title">단일 이미지</div>
                    <div className="feed-type-desc">이미지 1장 발행</div>
                    </div>
                    <div
                    className={`feed-type-card ${selectedFeedType === 'SLIDE' ? 'active' : ''}`}
                    onClick={() => this.selectFeedType('SLIDE')}
                    role="button"
                    >
                    <div className="feed-type-icon">🔄</div>
                    <div className="feed-type-title">슬라이드 이미지</div>
                    <div className="feed-type-desc">여러 장 슬라이드</div>
                    </div>
                </div>

                {selectedFeedType === 'SLIDE' && (
                    <>
                    <label className="form-label" style={{ marginTop: 16 }}>슬라이드 이미지 개수</label>
                    {this.renderSlideButtons()}
                    </>
                )}
                </div>

                {/* 상품 선택 로직 */}
                <div className="card">
                <h3 className="card-title">상품 선택 로직</h3>
                <div className="logic-grid">
                    {[
                    { key: 'ORDERS', icon: '🏆', title: '주문 많은 순', desc: '가장 많이 팔리는 베스트 상품부터', ex: '예시: 1위 원피스 → 2위 블라우스 → 3위 스커트...' },
                    { key: 'NEW', icon: '✨', title: '신상품 순', desc: '방금 등록한 최신 상품부터', ex: '예시: 오늘 등록 → 어제 등록 → 3일 전 등록...' },
                    { key: 'VIEWS', icon: '👁️', title: '조회수 높은 순', desc: '고객이 가장 많이 본 상품부터', ex: '예시: 조회 1,234회 → 조회 987회 → 조회 654회...' },
                    { key: 'ROBOMD', icon: '🤖', title: '로보MD 진열', desc: 'AI가 분석한 최적 상품 조합', ex: '예시: 계절 + 트렌드 + 재고 종합 분석' },
                    ].map((it) => (
                    <div
                        key={it.key}
                        className={`logic-card ${selectedLogic === it.key ? 'active' : ''}`}
                        onClick={() => this.selectLogic(it.key)}
                        role="button"
                    >
                        <div className="logic-icon">{it.icon}</div>
                        <div className="logic-title">{it.title}</div>
                        <div className="logic-desc">{it.desc}</div>
                        <div className="logic-example">{it.ex}</div>
                    </div>
                    ))}
                </div>

                {this.renderRoboMDList()}
                </div>

                {/* 문구 및 해시태그 */}
                <div className="card">
                <h3 className="card-title">문구 및 해시태그 설정</h3>
                <div className="grid-2">
                    {/* 문구 */}
                    <div>
                      <label className="form-label">문구 설정</label>
                      <div className="button-group mb-3">
                          <button
                          className={`button ${textMode === 'DIRECT' ? 'button-primary' : 'button-secondary'}`}
                          onClick={() => this.setTextMode('DIRECT')}
                          type="button"
                          >
                          직접 등록
                          </button>
                          <button
                          className={`button ${textMode === 'AI' ? 'button-primary' : 'button-secondary'}`}
                          onClick={() => this.setTextMode('AI')}
                          type="button"
                          >
                          AI 자동 생성
                          </button>
                          <button
                          className={`button ${textMode === 'LEARN' ? 'button-primary' : 'button-secondary'}`}
                          onClick={() => this.setTextMode('LEARN')}
                          type="button"
                          >
                          AI 내 피드 기반 자동 생성
                          </button>
                      </div>

                    {textMode === 'DIRECT' ? (
                        <div id="directTextSettings">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                            <span className="text-sm">직접 등록 문구</span>
                            <button className="add-button" type="button" onClick={this.addCustomText}>+ 추가</button>
                        </div>
                        <div id="customTexts">
                            {customTexts.map((t, i) => (
                            <div key={i} className="text-input-group">
                                <textarea
                                className="form-textarea"
                                value={t}
                                onChange={(e) => this.changeCustomText(i, e.target.value)}
                                placeholder="인스타그램 피드에 사용 할 문구를 입력해주세요."
                                />
                                <button className="delete-button" type="button" onClick={() => this.removeCustomText(i)}>×</button>
                            </div>
                            ))}
                        </div>
                        </div>
                    ) : textMode === 'AI' ? (
                        <div id="aiTextSettings">
                        {/* <textarea className="form-textarea" placeholder="AI가 상품에 맞는 문구를 자동으로 생성합니다" disabled /> */}
                        <TextInput
                            type="text"
                            id="text_user_prompt"
                            placeholder="AI 문구 생성 프롬프트 (예: 친근한 톤, 이모티콘 포함)"
                            value={this.state.textUserPrompt || ""}
                            height="45px"
                            // onChange={(e, value) => this.onChangeTopic(e, value)}
                            onChange={(e, value) => this.changeTextUserPrompt(value)}
                        />
                        </div>
                    ) : textMode === 'LEARN' ? (
                        <div id="learnTextSettings">
                            <div style={{ marginBottom: 8, height: 37, display: "flex", alignItems: "center" }}>
                              <span className="text-sm">최근 피드 문구</span>
                              <span style={{ fontSize: 12, color: "#6b7280", marginLeft: 8 }}>(선택한 개수: {selectedLearnedFeedCaptions ? selectedLearnedFeedCaptions.length : 0}개)</span>
                            </div>
                            {
                            feedCaptions ?
                              <>
                              <div 
                                className="robomd-list"
                                style={{
                                  marginTop: 0,
                                  maxHeight: 240,
                                  overflowY: "auto",
                                  border: "1px solid #e5e7eb",
                                  borderRadius: 6,
                                  padding: 12,
                                  backgroundColor: "#f9fafb",
                                }}>
                                  <>
                                    {
                                      feedCaptions.length > 0 ?
                                        feedCaptions.map((obj, idx) => (
                                          // <p key={idx} style={{ fontSize: 14, color: "#374151", marginBottom: 10, whiteSpace: "pre-wrap" }}>
                                          //   {cap}
                                          // </p>
                                          <button
                                            key={obj.instagram_media_id}
                                            type="button"
                                            className={`robomd-item ${
                                              selectedLearnedFeedCaptions.some(
                                                (item) => item.instagram_media_id == obj.instagram_media_id
                                              )
                                                ? 'active'
                                                : ''
                                            }`}
                                            // 필요에 따라 '정제된 캡션'을 넘기고 싶으면 cleanedCaption 사용
                                            onClick={() => this.selectLearnedFeed(obj.instagram_media_id, obj.caption)}
                                          >
                                            {obj.caption}
                                          </button>
                                        ))
                                        
                                      : 
                                        <div style={{ fontSize: 14, color: "#6b7280"} }>
                                          불러온 피드 문구가 없습니다. 
                                          {/* 인스타그램 계정의 최근 피드를 불러와 주세요. */}
                                        </div>
                                    }
                                  </>
                              </div>
                              <p style={{fontSize: 12, color: "#6b7280", marginTop: 8}}>
                                선택한 문구를 AI가 학습하여, 당신만의 스타일로 새로운 문장을 만들어드립니다.
                              </p>
                              </>
                            :
                              <>
                                <button className="button button-secondary" style={{width: "100%", justifyContent: "center"}}>내 인스타그램 피드 불러오기</button>  
                                <p style={{fontSize: 12, color: "#6b7280", marginTop: 8}}>
                                  최근 피드 문구를 AI가 학습하여, 당신만의 스타일로 새로운 문장을 만들어드립니다.
                                </p>
                              </>
                          }
                      </div>
                    ) : null }
                  </div>

                  {/* 해시태그 */}
                  <div>
                  <label className="form-label">해시태그 설정</label>
                  <div className="button-group mb-3">
                      <button
                      className={`button ${hashtagMode === 'BASIC' ? 'button-primary' : 'button-secondary'}`}
                      onClick={() => this.setHashtagMode('BASIC')}
                      type="button"
                      >
                      기본 해시태그
                      </button>
                      <button
                      className={`button ${hashtagMode === 'AI' ? 'button-primary' : 'button-secondary'}`}
                      onClick={() => this.setHashtagMode('AI')}
                      type="button"
                      >
                      AI 매번 생성
                      </button>
                  </div>

                  {hashtagMode === 'BASIC' ? (
                      <div id="hashtagSettings">
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                          <span className="text-sm">기본 해시태그</span>
                          <button className="add-button" type="button" onClick={this.addHashtag}>+ 추가</button>
                      </div>
                      <div id="hashtags">
                          {hashtags.map((h, i) => (
                          <div key={i} className="text-input-group">
                              {/* <input
                              type="text"
                              className="form-input"
                              value={h}
                              onChange={(e) => this.changeHashtag(i, e.target.value)}
                              placeholder="#해시태그를 입력해주세요."
                              /> */}
                              <TextInput
                                  type="text"
                                  id="hashtags"
                                  placeholder="#해시태그를 입력해주세요."
                                  value={h}
                                  height="45px"
                                  // onChange={(e, value) => this.onChangeTopic(e, value)}
                                  onChange={(e, value) => this.changeHashtag(i, value)}
                              />
                              <button className="delete-button" type="button" onClick={() => this.removeHashtag(i)}>×</button>
                          </div>
                          ))}
                      </div>
                      </div>
                  ) : (
                      <div id="aiHashtagSettings">
                      <input type="text" className="form-input" placeholder="AI가 피드 문구에 어울리는 해시태그를 자동 생성합니다" disabled />
                      </div>
                  )}
                  </div>
                </div>
                </div>

                {/* 발행 설정 */}
                <div className="card">
                <h3 className="card-title">발행 설정</h3>
                <div className="grid-2">
                    <div>
                        <label className="form-label">발행 주기</label>
                        <SelectBoxV2
                            id="publishCycle"                      // 셀렉트 식별자
                            className="form-select mb-3"           // 기존 클래스 유지 가능
                            pageWrapperName="common-page-wrapper"  // 바깥영역 클릭 시 닫힘 제어용 래퍼 ID
                            list={PUBLISH_CYCLE_OPTIONS}           // 옵션 리스트
                            optionTexttName="label"                // text 키
                            optionValuetName="value"               // value 키
                            selectedValue={this.state.publishCycle} // 현재 선택 값
                            selectedText={getLabelByValue(PUBLISH_CYCLE_OPTIONS, this.state.publishCycle)}
                            placeHolder="주기 선택"
                            onClickOption={(text, value, id) => {
                            // 기존 this.handleChange(e, 'root') 재사용을 위해 synthetic event 생성
                            const e = { target: { name: id, value } };
                            this.handleChange(e, 'root');
                            // 옵션 닫히는 동작은 SelectBoxV2가 내부에서 처리
                            }}
                            width="100%"
                            height="43px"
                        />

                      {
                         this.state.publishCycle !="DAILY" && this.state.publishCycle !="BIDAY" && 
                        <>
                          <label className="form-label">발행 요일</label>
                          {this.renderDayButtons()}
                        </>
                      }
                    </div>

                    <div>
                        <label className="form-label">발행 시간</label>
                        {/* <div className="button-group mb-3">
                            <button
                            className={`button ${timeMode === 'specific' ? 'button-primary' : 'button-secondary'}`}
                            onClick={() => this.setTimeMode('specific')}
                            type="button"
                            >
                            특정 시간대
                            </button>
                            <button
                            className={`button ${timeMode === 'random' ? 'button-primary' : 'button-secondary'}`}
                            onClick={() => this.setTimeMode('random')}
                            type="button"
                            >
                            랜덤 시간대
                            </button>
                        </div> */}

                        <div style={{marginBottom: "1rem"}}>
                            {timeMode === 'SPECIFIC' ? (
                                <>
                                {/* <label className="text-sm" style={{ color: '#6b7280', marginBottom: 8, display: 'block' }}>
                                    시간대 설정
                                </label> */}
                                <div className="time-input-group">
                                    {/* <input
                                    type="time"
                                    className="form-input"
                                    name="scheduledTime"
                                    value={scheduledTime}
                                    onChange={(e) => this.handleChange(e, 'root')}
                                    /> */}
                                    <DatePicker
                                        selected={this.getDateObjForTime()}
                                        onChange={this.onChangeTimePicker}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={60}
                                        timeCaption="시간"
                                        locale={ko}
                                        placeholderText="시간 선택"
                                        className="form-control"
                                        wrapperClassName="form-control"
                                        // 선택 가능한 시간대를 제한하려면 (예: 06:00~23:00)
                                        // minTime={new Date(`1970-01-01T06:00:00`)}
                                        // maxTime={new Date(`1970-01-01T23:00:00`)}
                                        dateFormat="aa hh:mm"
                                        timeFormat="aa hh:mm"
                                        renderCustomHeader={({ date, changeTime }) => {
                                          const hours = Array.from({ length: 12 }, (_, i) => i + 1);
                                          return (
                                            <div style={{ textAlign: 'center', padding: '4px' }}>
                                              {hours.map(h => (
                                                <button
                                                  key={h}
                                                  onClick={() => {
                                                    const newDate = new Date(date);
                                                    newDate.setHours(h);
                                                    changeTime(newDate);
                                                  }}
                                                  style={{ margin: '0 4px' }}
                                                >
                                                  {`오${h < 12 ? '전' : '후'} ${String(h).padStart(2, '0')}:00`}
                                                </button>
                                              ))}
                                            </div>
                                          );
                                        }}
                                    />
                                </div>
                                </>
                            ) : (
                                <div style={{ padding: 12, background: '#f9fafb', borderRadius: 8, fontSize: 14, color: '#6b7280' }}>
                                하루 중 랜덤한 시간에 자동으로 발행됩니다
                                </div>
                            )}
                        </div>
                        <label className="form-label">시작일</label>
                         <DatePicker
                            selected={this.getDateObjForDate()}
                            onChange={this.onChangeDatePicker}
                            dateFormat="yyyy-MM-dd"
                            locale={ko}
                            placeholderText="날짜 선택"
                            className="form-control"
                            wrapperClassName="form-control"
                            // minDate={new Date()} // 오늘 이후만 허용하려면
                        />
                    </div>
                </div>

                {/* <div className="mt-4">
                    <label className="form-label">시작일</label>
                    <DatePicker
                        selected={this.getDateObjForDate()}
                        onChange={this.onChangeDatePicker}
                        dateFormat="yyyy-MM-dd"
                        locale={ko}
                        placeholderText="날짜 선택"
                        className="form-control"
                        wrapperClassName="form-control"
                    />
                </div> */}
                </div>

                {/* 액션 버튼 */}
                <div className="action-buttons">
                {/* <button className="button button-secondary" type="button" onClick={this.showPreviewModal}>
                    미리보기
                </button> */}
                <button className="button button-primary" type="button" onClick={this.saveInstagramAutoProductSetting}>
                    자동 설정 저장
                </button>
                </div>
            </div>

            {/* 우측 미리보기 */}
            <div className="preview-panel" style={{display:"none"}}>
                {/* <h3 className="preview-header">실시간 미리보기</h3> */}
                <h3 className="preview-header">미리보기</h3>
                <div className="phone-preview">
                <div className="phone-frame">
                    <div className="phone-screen">
                    {/* 상단 바 간략화 */}
                    <div className="instagram-header">
                        <div className="profile-pic">
                          <img src={previewAccount.profile_picture_url || "https://via.placeholder.com/32"} alt="Profile" style={{ width: "100%", height: "100%", borderRadius: "50%" }} 
                            onError={(e) => {
                              e.currentTarget.onerror = null; // 루프 방지
                              e.currentTarget.style.display = 'none';
                            }}
                          />
                        </div>
                        <div className="profile-name">
                          {previewAccount.title}
                        </div>
                        <div className="more-icon">⋯</div>
                    </div>

                    <div className="feed-image-container"
                      style={{
                        aspectRatio: this.state.selectedRatio || '1/1',
                      }}
                    >
                        <div
                        className="previewContentBox"
                        style={{
                            background: content.bg,
                        }}
                        >
                        <div className="previewContentText">
                            {content.text.split('\n').map((line, i) => (
                            <span key={i}>
                                {line}
                                <br />
                            </span>
                            ))}
                        </div>
                        </div>
                        {this.renderCarouselDots()}
                    </div>

                    <div className="feed-actions">
                        <span className="feed-action">
                          <img src={"https://s3.ap-northeast-2.amazonaws.com/otdeal.file/icn_intagram/icon-like.svg"} style={{ width: 24, height: 24 }}></img>
                        </span>
                        <span className="feed-action">
                          <img src={"https://s3.ap-northeast-2.amazonaws.com/otdeal.file/icn_intagram/comment.svg"} style={{ width: 24, height: 24 }}></img>
                        </span>
                        <span className="feed-action">
                          <img src={"https://s3.ap-northeast-2.amazonaws.com/otdeal.file/icn_intagram/share.svg"} style={{ width: 24, height: 24 }}></img>
                        </span>
                        <span className="feed-action" style={{ marginLeft: 'auto' }}>
                          <img src={"https://s3.ap-northeast-2.amazonaws.com/otdeal.file/icn_intagram/bookmark.svg"} style={{ width: 24, height: 24 }}></img>
                        </span>
                    </div>

                    <div className="feed-caption">
                        <div className="feed-caption-text">
                        {caption.split('\n').map((line, i) => (
                          <React.Fragment key={i}>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: line.replace(/#([^\s#]+)/g, '<font color="#1e40af">#$1</font>')
                              }}
                            />
                            <br />
                          </React.Fragment>
                        ))}
                        </div>
                        <div className="feed-hashtags">{hashtagsText}</div>
                    </div>
                    </div>
                </div>
                </div>

                {/* 간단한 예측 수치 (정적) */}
                {/* <div className="preview-stats">
                  <div className="preview-stat">
                      <span className="preview-stat-label">예상 도달</span>
                      <span className="preview-stat-value">1.2K</span>
                  </div>
                  <div className="preview-stat">
                      <span className="preview-stat-label">참여율</span>
                      <span className="preview-stat-value">6.8%</span>
                  </div>
                  <div className="preview-stat">
                      <span className="preview-stat-label">예상 좋아요</span>
                      <span className="preview-stat-value">82</span>
                  </div>
                  <div className="preview-stat">
                      <span className="preview-stat-label">예상 댓글</span>
                      <span className="preview-stat-value">12</span>
                  </div> 
                </div> */}

                <div style={{ marginTop: 24, padding: 16, background: 'linear-gradient(135deg,#fef3c7 0%,#fed7aa 100%)', borderRadius: 12 }}>
                <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8, color: '#92400e' }}>💡 성과 향상 팁</div>
                <ul style={{ fontSize: 12, color: '#78350f', margin: 0, paddingLeft: 20, lineHeight: 1.8 }}>
                    <li>더 많은 이모지 사용으로 시선 끌기</li>
                    <li>해시태그 5-10개 추가 권장</li>
                    {/* <li>스토리와 연계 발행시 +40% 효과</li>
                    <li>릴스 전환시 도달율 10배 증가</li> */}
                </ul>
                </div>
            </div>
            </div>

            {/* 미리보기 모달 */}
            {/* {showPreview && (
            <div className="modal active" onClick={(e) => e.target.classList.contains('modal') && this.closePreviewModal()}>
                <div className="modal-content">
                <div className="modal-header">
                    <h3 className="modal-title">피드 미리보기</h3>
                    <button className="close-button" type="button" onClick={this.closePreviewModal}>×</button>
                </div>
                <div style={{ textAlign: 'center', padding: 20 }}>
                    <div style={{ display: 'inline-block', background: '#000', padding: 8, borderRadius: 24 }}>
                    <div style={{ background: 'white', borderRadius: 20, padding: 20, width: 300 }}>
                        <div
                        style={{
                            aspectRatio: '1 / 1',
                            background: content.bg,
                            borderRadius: 8,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                            fontSize: 20,
                            marginBottom: 16,
                            whiteSpace: 'pre-line',
                            textAlign: 'center',
                            fontWeight: 700,
                        }}
                        >
                        {content.text}
                        </div>
                        <div style={{ textAlign: 'left', fontSize: 14, lineHeight: 1.5, whiteSpace: 'pre-line' }}>
                        {caption}
                        {'\n'}
                        <span style={{ color: '#1e40af' }}>{hashtagsText}</span>
                        </div>
                    </div>
                    </div>
                </div>
                <div style={{ textAlign: 'center', marginTop: 20 }}>
                    <button className="button button-primary" type="button" onClick={this.closePreviewModal}>확인</button>
                </div>
                </div>
            </div>
            )} */}
        </div>
      </div>

      {
        /* 연결한 계정을 선택하는 팝업 */
        this.state.show_account_connect_popup && (
          <PopupFrameV2
            className={"account-connect-popup"}
            maxWidth={"950px"}
            onClose={() => this.setState({ show_account_connect_popup: false })}
          >
            <div className="instagram_account_page" style={{ paddingBottom: 52}}>
              <h5 style={{ marginBottom: 20 }}>연결할 인스타그램 계정을 선택해주세요</h5>
              {(this.state.add_account_list || []).map((account) => (
                // <div className="facebook-group">
                  <div className="instagram-accounts" key={account.token_id}>
                    {(Array.isArray(account.instagram_account_list)
                      ? account.instagram_account_list
                      : []
                    )
                      // 혹시 완전 빈 데이터(키값이 null) 들어오는 거 걸러내기
                      .filter((instagram) => instagram && instagram.instagram_access_token_seq)
                      .map((instagram) => (
                        <div
                          className="account-card"
                          key={instagram.instagram_access_token_seq}
                          onClick={(e) => {
                            if (e.target.closest('input[type="checkbox"], label')) return;
                            console.log("onClick");
                            let selected_account_list = [...this.state.selected_account_list];
                            const v = String(instagram.instagram_access_token_seq);

                            if (selected_account_list.includes(v)) {
                              // 이미 있으면 제거
                              console.log("onClick 이미 있으면 제거");
                              selected_account_list = selected_account_list.filter(seq => seq !== v);
                            } else {
                              // 없으면 추가
                              console.log("onClick 없으면 추가");
                              selected_account_list.push(v);
                            }

                            this.setState({ selected_account_list });
                            console.log("onClick 1");
                          }}
                          style={{
                            display: "flex",
                            gap: "18px",
                            cursor: "pointer",
                            userSelect: "none",
                            WebkitUserSelect: "none",
                            msUserSelect: "none",
                            WebkitUserDrag: "none",
                            WebkitTouchCallout: "none",
                          }}
                        >
                          <CheckBox
                            id={String(instagram.instagram_access_token_seq)}
                            value={String(instagram.instagram_access_token_seq)}
                            checked={this.state.selected_account_list.includes(
                              String(instagram.instagram_access_token_seq)
                            )}
                            onChangeCheck={(e) => {
                              console.log("onChangeCheck");
                              // e.preventDefault();

                              let selected_account_list = [...this.state.selected_account_list];
                              const v = String(instagram.instagram_access_token_seq);

                              if (selected_account_list.includes(v)) {
                                // 이미 있으면 제거
                                console.log("onChangeCheck 이미 있으면 제거");
                                selected_account_list = selected_account_list.filter(seq => seq !== v);
                              } else {
                                // 없으면 추가
                                console.log("onChangeCheck 없으면 추가");
                                selected_account_list.push(v);
                              }

                              this.setState({ selected_account_list });

                              console.log("onChangeCheck 1");
                            }}
                          />

                          <div className="account-wrapper">
                            <div className="account-left">
                              <div className="account-avatar">
                                {!!instagram.profile_picture_url && (
                                  <img src={instagram.profile_picture_url} alt="" />
                                )}
                              </div>
                              <div className="account-info">
                                <div className="account-username">
                                  {instagram.username || "(username 없음)"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                // </div>
              ))}
            </div>

            <div
              style={{
                display: "flex",
                width: "calc(100% - 24px)",
                justifyContent: "flex-end",
                position: "absolute",
                bottom: "0px",
                paddingBottom: "12px",
                // backgroundColor: "#fff",
              }}
            >
              <button className="btn btn-primary"
                onClick={() => {
                  this.updateSelectedAccountsUseYn();
                }}
              >
                연결하기
              </button>
            </div>
          </PopupFrameV2>
        )
      } 

      {/** 로딩 다이얼로그 */
        (this.state.save_dialog_show_state === true)
        ? <SaveDialogV2
            content={this.state.save_dialog_content}
            button_list={this.state.save_dialog_button_list}
        />
        : ''
      }
      {/* 안내 문구 전달용 기본 다이얼로그 */
        (this.state.basic_dialog_show_state === true)
          ? <BasicDialogV2
            content={this.state.basic_dialog_content}
            content2={this.state.basic_dialog_content2}
            button_list={this.state.basic_dialog_button_list}
          />
          : ''
      }
      {/* 경고 다이얼로그 */
        this.state.warning_dialog_show_state === true &&
        <WarningDialog
            content={this.state.warning_dialog_content}
            button_list={this.state.warning_dialog_button_list}
        />
      }
      {/* 확인 취소 다이얼로그 */
        (this.state.confirm_dialog_show_state === true)
        ? <ConfirmDialogV2
            content={this.state.confirm_dialog_content}
            button_list={this.state.confirm_dialog_button_list}
            popup_close={() => {
                this.setState({confirm_dialog_show_state: false});
            }}
        />
        : ''
      }

      {/** 로보 이미지 팝업 */
        this.state.show_robo_img_popup
        ?<RoboImgSettingPopup
            onClose={e => {this.setState({show_robo_img_popup:false})}}
            sendRoboImg={(img, stability_call_seq) => {
                this.applyAIImg(img, stability_call_seq);
                this.setState({show_robo_img_popup:false});
            }}
        />
        :""
      }
      {/** 상품 추가 팝업 */
        this.state.show_add_product_popup
        ? <SearchProductPopup
            title = {"상품 추가"}
            select_type = {"radio"}
            selected_product_list = {this.state.selected_rp_product_list || []}
            image_type_cd = {this.state.image_type_cd || ""}
            onClose = {() => {this.setState({show_add_product_popup:false})}}
            onSubmit = {this.onClickAddProductbtn.bind(this)}
            submit_btn_name = {"선택 상품 추가"}
        />
        : ""
      }
      </>
    );
  }
}

export default InstagramCreateProductAutomation;